(function ($) {
    $(document).ready(function () {
        $('.webinar-filter .dropdown-wrapper .dropdown').on('click', function () {
            $(this).closest('ul').toggleClass('active');
            $(this).siblings('.list').toggleClass('hide');
        });

        $('.dropdown-wrapper .list li').on('click', function () {
            $(this).addClass('selected').siblings().removeClass('selected');
            checkFilterSelection();
        });

        function checkFilterSelection() {
            if ($('.webinar-filter .filter-box .dropdown-wrapper .list li.selected').length > 0) {
                $('.webinar-filter .filter-box .clear-button').show();
            } else {
                $('.webinar-filter .filter-box .clear-button').hide();
            }
        }


        checkFilterSelection();

        const firstTab = $(".webinar-filter .filter-wrap .tab-list ul li").first();
        if (firstTab.length) {
            updateHeader(firstTab);
        }

        $(".webinar-filter .filter-wrap .tab-list ul li").click(function () {
            updateHeader(this);
        });

        $('.webinar-filter .filter-box .clear-button').on('click', function () {
            $('.webinar-filter .dropdown-wrapper ul').removeClass('active');
            $('.webinar-filter .dropdown-wrapper .list li').removeClass('selected');
            $('.webinar-filter .dropdown-wrapper .dropdown p').each(function () {
                const defaultText = $(this).data('default') || $(this).text();
                $(this).text(defaultText);
            });
            $('.webinar-filter .dropdown-wrapper .list').addClass('hide');
        });

        if ($(".webinar-filter").length > 0) {
            $('.webinar-filter .card-wrap .toggleable').prev().addClass('ellipsis');
            $('.webinar-filter .card-wrap .card').each(function () {
                var $textContent = $(this).find('.text-wrap p, .text-wrap ul');
                var len = $textContent.length;
                if (len > 1) {
                    $textContent.slice(1).hide().addClass('toggleable');
                    $(this).find('span.read-more').show();
                } else {
                    $(this).find('span.read-more').hide();
                }
            });
            $(".webinar-filter .card-wrap .card span.read-more").on("click", function () {
                const $this = $(this);
                const $toggleableContent = $this
                    .closest(".card")
                    .find(".text-wrap .toggleable");
                $toggleableContent.slideToggle();
                $this.toggleClass("active");
            });
        } 
        
    });
})(jQuery);


//Filters Js 

(function ($) {

    var $search = $(".webinar-filter .filter-box .search-box #search"),
        $category = $(".webinar-filter .filter-box .dropdown-wrapper ul li .category_checkbox"),
        $topic = $(".webinar-filter .filter-box .dropdown-wrapper ul li .topic_checkbox"),
        $product = $(".webinar-filter .filter-box .dropdown-wrapper ul li .product_checkbox"),
        $speaker = $(".webinar-filter .filter-box .dropdown-wrapper ul li .speaker_checkbox"),
        filter_items = ['all_search', 'all_topic', 'all_product', 'all_speaker', 'all_category'];
    filter_function(filter_items);

    var className;

    $('.webinar-filter .card-wrap .card .tag-list span').on('click', function () {
        className = $(this).attr("class"); var ID, $this = $(this);

        console.log(className);
        if (className === "topic") {
            ID = "topic-" + $this.attr("data-topic");
            var checkedCount_topic = $('.webinar-filter .filter-box .dropdown-wrapper .list-wrap#topic li input[type="checkbox"]:checked').length;
            var totalCount_topic = $('.webinar-filter .filter-box .dropdown-wrapper .list-wrap#topic li input[type="checkbox"]').length;
        } else if (className === "product") {
            ID = "product-" + $this.attr("data-product");
            var checkedCount_pro = $('.webinar-filter .filter-box .dropdown-wrapper .list-wrap#product li input[type="checkbox"]:checked').length;
        }
        $('#' + ID).trigger("click");

        if ($('.webinar-filter .filter-box .dropdown-wrapper .list-wrap .list').hasClass("hide")) {
            if (checkedCount_topic === 0) {
                $('.webinar-filter .filter-box .dropdown-wrapper #' + className + " .dropdown").trigger("click");
            }
            if (checkedCount_pro === 0) {
                $('.webinar-filter .filter-box .dropdown-wrapper #' + className + " .dropdown").trigger("click");
            }
        }
    });

    $('.webinar-filter .filter-box .clear-button').on('click', function () {
        $('.dropdown-wrapper .list li').removeClass('selected');
        $(".webinar-filter .filter-box .search-box #search").val("");
        $(".webinar-filter .filter-box .dropdown-wrapper ul li .category_checkbox").prop('checked', false);
        $(".webinar-filter .filter-box .dropdown-wrapper ul li .topic_checkbox").prop('checked', false);
        $(".webinar-filter .filter-box .dropdown-wrapper ul li .product_checkbox").prop('checked', false);
        $(".webinar-filter .filter-box .dropdown-wrapper ul li .speaker_checkbox").prop('checked', false);
        $(".webinar-filter .filter-wrap .tab-list ul li").removeClass("active");
        $(this).hide();
        $('.dropdown-wrapper .dropdown p').each(function () {
            const defaultText = $(this).data('default') || $(this).text();
            $(this).text(defaultText);
        });

        var display_date = $(".webinar-filter .filter-wrap .tab-list ul li.active").text();
        $(".webinar-filter .card-wrap h4").text(display_date);

        filter_items = ['all_search', 'all_topic', 'all_product', 'all_speaker', 'all_category'];
        filter_function(filter_items);
    });

    //Search Start 
    $search.on('keyup', function () {
        var searchText = $(this).val().toLowerCase();

        if (searchText === "all_search") {
            $(".webinar-filter .filter-box .clear-button").hide();
        } else {
            $(".webinar-filter .filter-box .clear-button").show();
        }
        if (searchText === "") {
            searchText = "all_search"
        }
        filter_items[0] = searchText;
        filter_function(filter_items)
    });
    //Search END

    // Category Start
    var  category_array = [];
    $category.on("change", function () {
        category_array = [];
        $('.webinar-filter .filter-box .dropdown-wrapper ul li .category_checkbox[type="checkbox"]:checked').each(function () {
            category_array.push($(this).attr('id'));
        });
        if (category_array.length === 0) {
            category_array = "all_category"
        }
        filter_items[4] = category_array;
        filter_function(filter_items);
    });

    // Category END

    //Topic Start
    var topic_array = [];
    $topic.on("change", function () {
        topic_array = [];
        $('.webinar-filter .filter-box .dropdown-wrapper ul li .topic_checkbox[type="checkbox"]:checked').each(function () {
            topic_array.push($(this).attr('id'));
        });
        if (topic_array.length === 0) {
            topic_array = "all_topic"
        }
        filter_items[1] = topic_array;
        filter_function(filter_items);
    });

    //Topic END


    //Product Start
    var product_arr = [];
    $product.on("change", function () {
        product_arr = [];
        $('.webinar-filter .filter-box .dropdown-wrapper ul li .product_checkbox[type="checkbox"]:checked').each(function () {
            product_arr.push($(this).attr('id'));
        });
        if (product_arr.length === 0) {
            product_arr = "all_product";
        }
        filter_items[2] = product_arr;
        filter_function(filter_items);

    });
    //Product END


    //Speaker Start
    var speaker_arrry = [];
    $speaker.on("change", function () {
        speaker_arrry = [];
        $('.webinar-filter .filter-box .dropdown-wrapper ul li .speaker_checkbox[type="checkbox"]:checked').each(function () {
            speaker_arrry.push($(this).attr('id'));
        });
        if (speaker_arrry.length === 0) {
            speaker_arrry = "all_speaker";
        }
        filter_items[3] = speaker_arrry;
        filter_function(filter_items)

    });
    //Speaker END


    // filter_function start 

    function filter_function(filter_items_arr) {
        var search_term = filter_items_arr[0].toLowerCase(),
        topic_term = Array.isArray(filter_items_arr[1]) ? filter_items_arr[1] : [filter_items_arr[1]],
        product_term = Array.isArray(filter_items_arr[2]) ? filter_items_arr[2] : [filter_items_arr[2]],
        speaker_term = Array.isArray(filter_items_arr[3]) ? filter_items_arr[3] : [filter_items_arr[3]],
        category_term = Array.isArray(filter_items_arr[4]) ? filter_items_arr[4] : [filter_items_arr[4]];

        console.log(filter_items_arr);

        $(".webinar-filter .card-wrap .card").addClass('hide').removeClass('show');
        $('.webinar-filter .card-wrap .card').each(function () {
            var $card = $(this);
            if (!$card.data('search') || !$card.data('topic') || !$card.data('product') || !$card.data('speaker') || !$card.data('date')) {
                return;
            }
            var matchSearchTerm = $card.data('search').toLowerCase().includes(search_term);

            var categoryFilters = $card.data('category').split(" ").filter(val => {
                return val !== ""
            })

            var topicFilters = $card.data('topic').split(" ").filter(val => {
                return val !== ""
            })

            var productFilters = $card.data('product').split(" ").filter(val => {
                return val !== ""
            })

            var speakerFilters = $card.data('speaker').split(" ").filter(val => {
                return val !== ""
            })

            let matchCategory = category_term.every((e) => {
                return categoryFilters.includes(e)
            })

            let matchTopic = topic_term.every((e) => {
                return topicFilters.includes(e)
            })

            var matchProduct = product_term.every((e) => {
                return productFilters.includes(e)
            })

            var matchSpeaker = speaker_term.every((e) => {
                return speakerFilters.includes(e)
            })

            if (matchSearchTerm && matchCategory && matchTopic && matchProduct && matchSpeaker) {
                $card.removeClass('hide').addClass('show');
            }
        });

        var show_card = $(".webinar-filter .card-wrap .card").length
        var hide_card = $(".webinar-filter .card-wrap .card.hide").length
        if (show_card === hide_card) {
            $('.webinar-filter .card-wrap .no-result').removeClass("hide").addClass("show");
        } else {
            $('.webinar-filter .card-wrap .no-result').removeClass("show").addClass("hide");
        }
        if (filter_items_arr[0] === "all_search" && filter_items_arr[1] === "all_topic" && filter_items_arr[2] === "all_product" && filter_items_arr[3] === "all_speaker" && filter_items_arr[4] === "all_category") {
            $('.webinar-filter .filter-box .clear-button').hide();
        }
    }
})(jQuery);